<div
  class="flex flex-col items-center justify-between gap-4 md:flex-row"
  [attr.data-testid]="'section-header'">
  <ng-content></ng-content>
</div>
